import React from "react";
import { Typography, Message } from "components";
import styles from "./InputError.module.css";

interface InputErrorProps {
  error?: string;
  errorId?: string;
}

// Internal component should be used only by other inputs
// Should not be exported from components

const InputError: React.FC<InputErrorProps> = ({ error, errorId = "" }) => {
  if (!error) {
    return null;
  }
  return (
    <Message type="error" shape="sharp" className={styles.errorMessage}>
      <Typography
        component="span"
        variant="c2"
        id={errorId}
        aria-live="assertive"
        role="alert"
      >
        {error}
      </Typography>
    </Message>
  );
};

export default InputError;
